import { toTitleCase } from '@libs/core';
import type { MappedProductVariant, ProductCategory, ProductHit } from '../types';
import { getMappedBrandName } from './brandMapping';
import { SORT_INDEX_PLP } from './filters';

export const getSortUrlValueFromIndex = (index: string) => SORT_INDEX_PLP.items.find(i => i.value === index)?.urlValue;

export const getSortIndexFromUrlValue = (urlValue: string) =>
    SORT_INDEX_PLP.items.find(i => i.urlValue === urlValue)?.value;

export const getSortLabelFromIndex = (index: string) => SORT_INDEX_PLP.items.find(i => i.value === index)?.label;

export const removeSpaceFromAmbersand = (name: string) => name.replace(/ & /g, '&');

export const repalceAndwithAmbersand = (name: string) => name.replace(/and/g, '&');

export const replaceAmbersandWithAnd = (name: string) => name.replace(/&/g, 'and');

export const denormalizeAlgoliaFilterName = (name: string) =>
    getMappedBrandName(toTitleCase(name.replace(/-/g, ' ').replace(/ and /g, ' & ')));

export const normalizeAlgoliaFilterName = (name: string) =>
    name.trim().replace(/ /g, '-').replace(/&/g, 'and').replace(/'/g, '').toLowerCase();

export const normalizeAlgoliaCategory = (category: ProductCategory) =>
    category.name.default.trim().replace(/ /g, '-').toLowerCase();

export const normalizeAlgoliaCategories = (categories: ProductCategory[]) =>
    categories.length > 0 ? categories.reverse().map(normalizeAlgoliaCategory).join('/') : '/';

export const getDefaultCategories = (product: ProductHit | MappedProductVariant) => {
    const primaryCategoryId = product.primary_category_id;

    const categories = product.categories?.find(category => category.find(c => c.id === primaryCategoryId));

    if (!categories) {
        return [];
    }

    if (primaryCategoryId === categories?.[0].id) {
        return categories.slice().reverse() ?? [];
    }

    return categories.slice();
};
